import React from 'react';

export const BeneficiaryDescription = () => (
  <p>
    <strong>Note:</strong> A beneficiary is the person currently getting CHAMPVA
    benefits.
  </p>
);

export const MultipleUpdatesDescription = () => (
  <p>
    <strong>Note:</strong> If you need to submit an update for multiple people,
    you’ll need to submit a separate update for each person.
  </p>
);
